// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__36FKK","avatar":"style_avatar__1HhvD"};